import { useEffect } from "react";
import {
  GET_OUTLET_GROUP,
  GET_OUTLET_GROUP_SAVE,
  GET_OUTLETS_DETAILS,
  UPLOAD_API,
} from "../../../../helpers/constants/apiUrl";
import { triggerSimpleAjax } from "../../../../helpers/httpHelper";
import triggerNotification from "../../../../actions/triggerNotification";
import _cloneDeep from "lodash/cloneDeep";

export const outletQuestionGroupSaveAction = ({
  outletGroupDetails = [],
  setRequestInProcess = () => { },
  setSaveClickedData = () => { },
  setActiveQuestionGroupIndex = () => { },
  activeGroupIndex,
  saveClickedData,
  question_groups,
  setOutletGroupDetails = () => { },
  setOutletGroupDetailsCopy = () => { },
  setActiveGroupIndex = () => { },
  setErrorDetails = () => { },
  sku_request_body = false,
  isBackgroundRequest = false,
  outletDetails,
  question_and_answers = {},
  activeQuestionGroupIndex = null,
  triggerNotificationFn = triggerNotification,
  sliderRef = null,
}) => {


  let has_edited = false;
  let reqData = {};
  if (sku_request_body) {
    reqData = sku_request_body;

    const update_data = Object.keys(
      sku_request_body.data_to_update || {}
    ).reduce((answerObject, val) => {
      const item = sku_request_body.data_to_update[val];
      if (item?.is_edited) {
        answerObject[val] = item;
        has_edited = true;
      }
      return answerObject;
    }, {});

    sku_request_body.data_to_update =
      Object.keys(update_data).length > 0 ? update_data : null;

    // Filter and clean data_to_update
    sku_request_body.data_to_update =
      Object.keys(update_data).length > 0 ? update_data : null;

    // Clean data_to_create if it's empty
    if (
      !Array.isArray(sku_request_body.data_to_create) ||
      sku_request_body.data_to_create.length === 0
    ) {
      sku_request_body.data_to_create = null;
    }

    // Set has_edited flag properly
    has_edited =
      !!sku_request_body.data_to_create || !!sku_request_body.data_to_update;
  }
  else {
    // reqData = {
    //   object_type: "answers",
    //   data_to_create: null,
    //   data_to_update: outletGroupDetails.reduce((answerObject, question) => {
    //     if (
    //       !question.type.includes("image") &&
    //       question["related_answers"][0]?.is_edited
    //     ) {
    //       answerObject[question["related_answers"][0]["id"]] = {
    //         ...question["related_answers"][0],
    //       };
    //       has_edited = true;
    //     }

    //     return answerObject;
    //   }, {}),
    // };

    const data_to_create = [];
    const data_to_update = {};

    outletGroupDetails.forEach((question) => {
      const answer = question["related_answers"]?.[0];

      if (!answer) return;
      if (question.type === "upload_file") return;

      let other_bank_name = null
      let other_branch_name = null

      if (question.type.includes("account_number")) {
        other_bank_name = answer.verified_secondary == true ? answer.other_bank_name || null : null
        other_branch_name = answer.verified_secondary == true ? answer.other_branch_name || null : null
      } else if (question.type.includes("ifsc_code")) {
        other_bank_name = answer.verified == true ? answer.other_bank_name || null : null
        other_branch_name = answer.verified == true ? answer.other_branch_name || null : null
      }

      if (!answer.id) {
        // No ID = new answer, so push to data_to_create



        data_to_create.push({
          question: question.id,
          workflow_object: outletDetails.workflow_object,

          // main value
          single_input: answer.single_input === "" ? null : answer.single_input,
          location_hierarchy: answer.location_hierarchy || null,

          // account_number extras
          other_phone_number: answer.other_phone_number || null,
          other_ifsc_code: answer.other_ifsc_code || null,


          other_bank_name: other_bank_name, //answer.verified == true ? answer.other_bank_name || null : null,
          other_branch_name: other_branch_name,  //answer.verified == true ? answer.other_branch_name || null : null,
          other_account_holder_name: answer.verified == true ? answer.other_account_holder_name || null : null,

          // PAN extras
          other_pan_holder_name: answer.verified == true ? answer.other_pan_holder_name || null : null,

          // GST extras
          other_gst_trade_name: answer.verified == true ? answer.other_gst_trade_name || null : null,
          other_gst_legal_name: answer.verified == true ? answer.other_gst_legal_name || null : null,
          other_gst_registration_status: answer.verified == true ? answer.other_gst_registration_status || null : null,

          // UPI extras
          other_upi_account_name: answer.other_upi_account_name || null,

          // verification flags
          verified: answer.verified || false,
          verified_secondary: answer.verified_secondary || false,

          single_image_input: answer.single_image_input || null,
          multiple_images_input: answer.multiple_images_input || [],

          temp_index: answer.temp_index,
        });

        has_edited = true;
      } else if (!question.type.includes("image") && answer.is_edited) {
        // Has ID and edited = update existing
        data_to_update[answer.id] = {
          ...answer,
          single_input:
            answer.single_input === "" ? null : answer.single_input,
          other_ifsc_code:
            answer.other_ifsc_code === "" || !answer.other_ifsc_code ? null : answer.other_ifsc_code,
          other_phone_number:
            answer.other_phone_number === "" || !answer.other_phone_number ? null : answer.other_phone_number,
          // Bank extras

          other_bank_name: other_bank_name,//answer.verified ? answer.other_bank_name : null,
          other_branch_name: other_branch_name,//answer.verified ? answer.other_branch_name : null,
          other_account_holder_name: answer.verified ? answer.other_account_holder_name : null,

          // PAN extras
          other_pan_holder_name: answer.verified ? answer.other_pan_holder_name : null,

          // GST extras
          other_gst_trade_name: answer.verified ? answer.other_gst_trade_name : null,
          other_gst_legal_name: answer.verified ? answer.other_gst_legal_name : null,
          other_gst_registration_status: answer.verified ? answer.other_gst_registration_status : null,
        };
        delete data_to_update[answer.id][""];
        has_edited = true;
      }
    });

    reqData = {
      object_type: "answers",
      data_to_create: data_to_create.length > 0 ? data_to_create : null,
      data_to_update: Object.keys(data_to_update).length > 0 ? data_to_update : null,
    };
  }

  setRequestInProcess(true);
  if (has_edited) {
    triggerSimpleAjax(
      `${GET_OUTLET_GROUP_SAVE}`,
      "POST",
      reqData,
      (response) => {
        let isDataModified = false;

        if (Array.isArray(response?.data_to_update)) {
          response.data_to_update.forEach((answer = {}) => {
            if (!answer?.question || !answer?.id) return;

            outletGroupDetails.forEach((outlet, index) => {
              if (String(outlet.id) === String(answer.question)) {
                const updatedAnswersArray = (
                  outlet.related_answers || []
                ).filter((outletData) => outletData.id !== answer.id);
                if (answer.answer_type !== "multiple_choice") {
                  outletGroupDetails[index].related_answers = [
                    ...updatedAnswersArray,
                    answer,
                  ];
                  isDataModified = true;

                  // CRITICAL: Also update question_and_answers cache so data persists when navigating back
                  if (activeQuestionGroupIndex && question_and_answers[activeQuestionGroupIndex.group_index]) {
                    const cachedQuestionIndex = question_and_answers[activeQuestionGroupIndex.group_index].findIndex(
                      q => String(q.id) === String(answer.question)
                    );
                    if (cachedQuestionIndex !== -1) {
                      question_and_answers[activeQuestionGroupIndex.group_index][cachedQuestionIndex].related_answers = [
                        ...updatedAnswersArray,
                        answer,
                      ];
                    }
                  }
                }
              }
            });
          });
        }

        if (Array.isArray(response?.data_to_create)) {
          response.data_to_create.forEach((answer = {}) => {
            if (!answer?.question || !answer?.id) return;

            const outletIndex = outletGroupDetails.findIndex(
              outlet => String(outlet.id) === String(answer.question)
            );

            if (outletIndex !== -1) {
              const existingAnswers =
                outletGroupDetails[outletIndex].related_answers || [];

              // ✅ Prevent duplicate
              const alreadyExists = existingAnswers.some(
                item => String(item.id) === String(answer.id)
              );

              if (!alreadyExists) {
                outletGroupDetails[outletIndex].related_answers = [
                  ...existingAnswers,
                  answer,
                ];
                isDataModified = true;
              }
            }

            // ✅ Update cache safely
            if (
              activeQuestionGroupIndex &&
              question_and_answers?.[activeQuestionGroupIndex.group_index]
            ) {
              const group =
                question_and_answers[activeQuestionGroupIndex.group_index];

              const cachedQuestionIndex = group.findIndex(
                q => String(q.id) === String(answer.question)
              );

              if (cachedQuestionIndex !== -1) {
                const existingCachedAnswers =
                  group[cachedQuestionIndex].related_answers || [];

                const alreadyExistsInCache = existingCachedAnswers.some(
                  item => String(item.id) === String(answer.id)
                );

                if (!alreadyExistsInCache) {
                  group[cachedQuestionIndex].related_answers = [
                    ...existingCachedAnswers,
                    answer,
                  ];
                }
              }
            }
          });
        }

        if (isDataModified) {
          setOutletGroupDetails([...outletGroupDetails]);
          setOutletGroupDetailsCopy(_cloneDeep(outletGroupDetails));
        }

        // setOutletGroupDetails(outletGroupDetails);
        // setOutletGroupDetailsCopy(_cloneDeep(outletGroupDetails));
        setRequestInProcess(false);
        if (!isBackgroundRequest) {
          setSaveClickedData({
            ...(saveClickedData || {}),
            [activeGroupIndex]: true,
          });

          if (activeGroupIndex < (question_groups || []).length - 1) {
            const nextIndex = activeGroupIndex + 1;
            setActiveGroupIndex(nextIndex);
            const nextQGroup = question_groups[nextIndex];
            setActiveQuestionGroupIndex({
              group_index: nextQGroup?.id,
              position_index: nextIndex,
            });
            if (sliderRef?.current?.slickGoTo) {
              const targetSlide = Math.max(0, Math.min(nextIndex, (question_groups || []).length - 4));
              sliderRef.current.slickGoTo(targetSlide);
            }
          }
        }
      },
      (err) => {
        setRequestInProcess(false);
        setErrorDetails(err.data_to_update);
        triggerNotificationFn({
          messageText: err?.message || err?.result?.[0] || "Something went wrong",
          status: "FAILED",
        });
      }
    );
  } else {
    setRequestInProcess(false);
    setSaveClickedData({
      ...(saveClickedData || {}),
      [activeGroupIndex]: true,
    });
    if (activeGroupIndex < (question_groups || []).length - 1) {
      const nextIndex = activeGroupIndex + 1;
      setActiveGroupIndex(nextIndex);
      const nextQGroup = question_groups[nextIndex];
      setActiveQuestionGroupIndex({
        group_index: nextQGroup?.id,
        position_index: nextIndex,
      });
      if (sliderRef?.current?.slickGoTo) {
        const targetSlide = Math.max(0, Math.min(nextIndex, (question_groups || []).length - 4));
        sliderRef.current.slickGoTo(targetSlide);
      }
    }
  }
};

